// extracted by mini-css-extract-plugin
module.exports = {"container":"toggleHistory__container___3wSx3","icon":"toggleHistory__icon___2vDbG","is-enable":"toggleHistory__is-enable___32mOq"};